import React, { useState, useEffect } from 'react';
import { Badge, Button, Dropdown, Table, Modal, Input } from 'antd';
import _, { forEach, isArray } from 'lodash';
import { uploadIdentityverification, approveRejectIdentifyVerification, approveRejectUserDocument, approveRejectBusiness, approveRejectResidentileDetail, approveRejectBankDetail, approveRejectFirmDetail, approveRejectExpDetail, approveRejectTraDetail, approveRejectEduDetail, approveRejectEducationDetail, approveRejectExpAllDetail, approveRejectTrainAllDetail, approveRejectEduAllDetail, updateUserPrimaryBuisiness, approveRejectVehicleAllDetail } from '../action/user.actions'
import { useDispatch } from 'react-redux'
import './dummyTable.scss'
import axios from 'axios';
import { apiEndPoint, imageEndpoint } from '../../../services/endpoint';
// import Zoom from 'react-medium-image-zoom'
// import 'react-medium-image-zoom/dist/styles.css'
const items = [
  {
    key: '1',
    label: 'Action 1',
  },
  {
    key: '2',
    label: 'Action 2',
  },
];

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
// Modal.setAppElement('#root');
const TableComponent = (columnsDetails) => {
  const dispatch = useDispatch()
  console.log("ds")
  const [customerData, setCustomerData] = useState([]);
  const [ProviderData, setProviderData] = useState([]);
  const [userData, setUserData] = useState(columnsDetails.dataSource || []);
  const [currentSelectedDoc, setCurrentSelectedDoc] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updatedUserData, setUpdatedUserData] = useState([])
  const [loggedInUser, setLoggedInUser] = useState("");
  const [remarks, setRemarks] = useState({});
  const [sortOrder, setSortOrder] = useState(null);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [allCategories, setAllCategories] = useState([])

  useEffect(() => {
    let loggedInUserDetail = JSON.parse(localStorage.getItem("user"));
    setLoggedInUser(loggedInUserDetail.username);
    if (columnsDetails && columnsDetails.dataSource) {
      _.forEach(columnsDetails.dataSource, function (data) {
        data.rejected = countRejectedDocuments(data.user_profile)
        data.total = countDocuments(data.user_profile);
        data.verified = countVerifiedDocuments(data.user_profile);
        data.pending = countPendingDocuments(data.user_profile);
      })
      let sortedData = _.sortBy(columnsDetails.dataSource, 'created_at').reverse();
      if (columnsDetails.type == 'C') {
        sortedData = _.filter(sortedData, function (data) { return data.role == 'Customer' })
      } else {
        sortedData = _.filter(sortedData, function (data) { return data.role == 'Provider' })
      }
      setUserData(sortedData)
      setUpdatedUserData(sortedData)
      const editRemark = {};
      sortedData.forEach((e => {
        if (e.user_profile.bank_detail.documents) {
          e.user_profile.bank_detail.documents.forEach(doc => {
            editRemark[doc.id] = doc.remark;
          })
        }
        if (e.user_profile.firm_address.documents) {
          e.user_profile.firm_address.documents.forEach(doc => {
            editRemark[doc.id] = doc.remark;
          })
        }
        if (e.user_profile.identity_verification.documents) {
          e.user_profile.identity_verification.documents.forEach(doc => {
            editRemark[doc.id] = doc.remark;
          })
        }
        if (e.user_profile.residential_address.documents) {
          e.user_profile.residential_address.documents.forEach(doc => {
            editRemark[doc.id] = doc.remark;
          })
        }
        if (e.user_profile.educational_qualification.length > 0) {
          e.user_profile.educational_qualification.forEach(doc => {
            if (doc.documents.length) {
              editRemark[doc.documents[0].id] = doc.documents[0].remark;
            }
          })
        }
        if (e.user_profile.experience.length > 0) {
          e.user_profile.experience.forEach(doc => {
            if (doc.documents.length) {
              editRemark[doc.documents[0].id] = doc.documents[0].remark;
            }
          })
        }
        if (e.user_profile.training.length > 0) {
          e.user_profile.training.forEach(doc => {
            if (doc.documents.length) {
              editRemark[doc.documents[0].id] = doc.documents[0].remark;
            }
          })
        }
      }))
      setRemarks(editRemark)
      axios({
        url: `${apiEndPoint}/categories/`,
        method: 'GET',
      }).then((response) => {
        setAllCategories(response.data.data)
      })
    }
  }, [columnsDetails])

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (sortOrder) {
      let editUserData = [...updatedUserData]
      if (sortedColumn) {
        // editUserData = editUserData.sort((a, b) => {
        //   if (sortOrder === 'asc') {
        //     return a[sortedColumn] - b[sortedColumn];
        //   } else {
        //     return b[sortedColumn] - a[sortedColumn];
        //   }
        // })
        editUserData = _.orderBy(editUserData, [sortedColumn], [sortOrder])

      }
      setUpdatedUserData(editUserData);
    }
  }, [sortOrder])

  const handleSort = (column) => {
    if (column === sortedColumn) {
      setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortedColumn(column);
      setSortOrder('asc');
    }
  };

  function countDocuments(obj) {
    let count = 0;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (Array.isArray(value) && key !== "documents") {
          value.forEach(item => {
            count += countDocuments(item);
          });
        } else if (key === "documents" && Array.isArray(value)) {
          count += value.length;
        } else if (typeof value === "object" && value !== null) {
          count += countDocuments(value);
        }
      }
    }
    return count;
  }

  function countVerifiedDocuments(obj) {
    let count = 0;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (Array.isArray(value) && key !== "documents") {
          value.forEach(item => {
            count += countVerifiedDocuments(item);
          });
        } else if (key === "documents" && Array.isArray(value)) {
          count += value.filter(doc => doc.status === "Verified").length;
        } else if (typeof value === "object" && value !== null) {
          count += countVerifiedDocuments(value);
        }
      }
    }
    return count;
  }

  function countRejectedDocuments(obj) {
    let count = 0;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (Array.isArray(value) && key !== "documents") {
          value.forEach(item => {
            count += countRejectedDocuments(item);
          });
        } else if (key === "documents" && Array.isArray(value)) {
          count += value.filter(doc => doc.status === "Rejected").length;
        } else if (typeof value === "object" && value !== null) {
          count += countRejectedDocuments(value);
        }
      }
    }
    return count;
  }

  function countPendingDocuments(obj) {
    let count = 0;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (Array.isArray(value) && key !== "documents") {
          value.forEach(item => {
            count += countPendingDocuments(item);
          });
        } else if (key === "documents" && Array.isArray(value)) {
          count += value.filter(doc => doc.status === "Pending Verification").length;
        } else if (typeof value === "object" && value !== null) {
          count += countPendingDocuments(value);
        }
      }
    }
    return count;
  }

  const approveReject = (selectedRecord, status, type) => {
    const dataBody = {
      user_id: selectedRecord.verificationData.user_id || selectedRecord.verificationData[0].user_id,
      status: status
    }
    if (selectedRecord.verificationType == "Identity Verification") {

      dispatch(approveRejectIdentifyVerification(dataBody)).then((res) => {
        const newData = []
        _.forEach(updatedUserData, function (data) {
          if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].status) {
            data.user_profile[type].status = status == "V" ? "Verified" : "Rejected";
          }
          newData.push(data)
        })
        setUserData(newData)
      })
        .catch((err) => {
          console.log(err);
        })
    } else if (selectedRecord.verificationType == "Residential Verification") {
      dispatch(approveRejectResidentileDetail(dataBody)).then((res) => {
        const newData = []
        _.forEach(updatedUserData, function (data) {
          if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].status) {
            data.user_profile[type].status = status == "V" ? "Verified" : "Rejected";
          }
          newData.push(data)
        })
        setUserData(newData)
      })
        .catch((err) => {
          console.log(err);
        })
    } else if (selectedRecord.verificationType == "Bank Verification") {
      dispatch(approveRejectBankDetail(dataBody)).then((res) => {
        const newData = []
        _.forEach(updatedUserData, function (data) {
          if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].status) {
            data.user_profile[type].status = status == "V" ? "Verified" : "Rejected";
          }
          newData.push(data)
        })
        setUserData(newData)
      })
        .catch((err) => {
          console.log(err);
        })
    } else if (selectedRecord.verificationType == "Firm Verification") {
      dispatch(approveRejectFirmDetail(dataBody)).then((res) => {
        const newData = []
        _.forEach(updatedUserData, function (data) {
          if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].status) {
            data.user_profile[type].status = status == "V" ? "Verified" : "Rejected";
          }
          newData.push(data)
        })
        setUserData(newData)
      })
        .catch((err) => {
          console.log(err);
        })
    } else if (selectedRecord.verificationType == "Educational Verification") {
      dispatch(approveRejectEduAllDetail(dataBody)).then((res) => {
        const newData = []
        let stop = false
        _.forEach(updatedUserData, function (data) {
          if (!stop) {
            if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].length) {
              const newArr = _.map(data.user_profile[type], (d) => {
                d.status = status == "V" ? "Verified" : "Rejected";
                if (!stop) {
                  if (d.documents.length) {
                    d.documents[0].status = status == "V" ? "Verified" : "Rejected";
                  } else {
                    stop = true
                    alert('Please upload documents to continue.');

                  }
                }
                return d
              })
              data.user_profile[type] = [...newArr];
              newData.push(newArr)
            }
          }


        })
        setUserData(newData)
      })
        .catch((err) => {
          alert('Please upload documents to continue.')
          console.log(err);
        })
    } else if (selectedRecord.verificationType == "Experience Verification") {
      dispatch(approveRejectExpAllDetail(dataBody)).then((res) => {
        const newData = []
        let stop = false
        _.forEach(updatedUserData, function (data) {
          if (!stop) {
            if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].length) {
              const newArr = _.map(data.user_profile[type], (d) => {
                d.status = status == "V" ? "Verified" : "Rejected";
                if (!stop) {
                  if (d.documents.length) {
                    d.documents[0].status = status == "V" ? "Verified" : "Rejected";
                  } else {
                    stop = true
                    alert('Please upload documents to continue.');

                  }
                }
                return d
              })
              data.user_profile[type] = [...newArr];
              newData.push(newArr)
            }
          }


        })
        setUserData(newData)
      })
        .catch((err) => {
          alert('Please upload documents to continue.')
        })
    } else if (selectedRecord.verificationType == "Training Verification") {
      dispatch(approveRejectTrainAllDetail(dataBody)).then((res) => {
        const newData = []
        let stop = false
        _.forEach(updatedUserData, function (data) {
          if (!stop) {
            if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].length) {
              const newArr = _.map(data.user_profile[type], (d) => {
                d.status = status == "V" ? "Verified" : "Rejected";
                if (!stop) {
                  if (d.documents.length) {
                    d.documents[0].status = status == "V" ? "Verified" : "Rejected";
                  } else {
                    stop = true
                    alert('Please upload documents to continue.');

                  }
                }
                return d
              })
              data.user_profile[type] = [...newArr];
              newData.push(newArr)
            }
          }


        })
        setUserData(newData)
      })
        .catch((err) => {
          alert('Please upload documents to continue.')
        })
    } else if (selectedRecord.verificationType == "Vehicle Registration") {
      dispatch(approveRejectVehicleAllDetail(dataBody)).then((res) => {
        const newData = []
        let stop = false
        _.forEach(updatedUserData, function (data) {
          if (!stop) {
            if (data.id == dataBody.user_id && data.user_profile[type] && data.user_profile[type].length) {
              const newArr = _.map(data.user_profile[type], (d) => {
                d.status = status == "V" ? "Verified" : "Rejected";
                if (!stop) {
                  if (d.documents.length) {
                    _.map(d.documents, (doc) => {
                      doc.status = status == "V" ? "Verified" : "Rejected";
                    })
                    //d.documents[0].status = status == "V" ? "Verified" : "Rejected";
                  } else {
                    stop = true
                    alert('Please upload documents to continue.');

                  }
                }
                return d
              })
              data.user_profile[type] = [...newArr];
              newData.push(newArr)
            }
          }


        })
        setUserData(newData)
      })
        .catch((err) => {
          alert('Please upload documents to continue.')
        })
    }
  }

  const approveRejectPrimaryBusiness = (selectedRecord, status) => {
    const data = {
      user_id: selectedRecord.user_id,
      status: status,
      id: selectedRecord.id
    }
    dispatch(approveRejectBusiness(data)).then((res) => {
      const newData = []
      _.forEach(updatedUserData, function (data) {
        if (data.user_profile['primary_business'] && data.user_profile['primary_business'].length > 0) {
          _.forEach(data.user_profile['primary_business'], function (business) {
            if (business.id == selectedRecord.id)
              business.status = status == "V" ? "Verified" : "Rejected";
          })
        }
        newData.push(data)
      })
      setUserData(newData)
    })
      .catch((err) => {
        console.log(err);
      })
  }

  const approveRejectDocuments = (selectedRecord, status, type) => {
    const data = {
      document_id: selectedRecord.id,
      status: status,
      user_id: selectedRecord.user_id,
      approved_by: loggedInUser,
      remark: remarks[selectedRecord.id] || '',
    }
    dispatch(approveRejectUserDocument(data)).then((res) => {
      const newData = []
      _.forEach(updatedUserData, function (data) {
        if (type == 'experience' || type == 'educational_qualification' || type == 'training' || type == 'vehicle_registration') {
          const dataUpdate = {
            user_id: selectedRecord.user_id,
            status: status,
            id: selectedRecord.data_id
          }
          if (type == 'experience') {
            dispatch(approveRejectExpDetail(dataUpdate));
          } else if (type == 'educational_qualification') {
            dispatch(approveRejectEduDetail(dataUpdate));
          } else if (type == 'training') {
            dispatch(approveRejectTraDetail(dataUpdate));
          }
          if (data.user_profile[type] && data.user_profile[type].length > 0) {
            if(type == 'vehicle_registration'){
              _.forEach(data.user_profile[type], function (document) {
                if (document.documents && document.documents.length > 0) {
                  _.forEach(document.documents, function(doc){
                    if(doc.id == selectedRecord.id){
                      if (doc.status == "Pending Verification") {
                        data.pending = data.pending - 1
                      } else if (doc.status == "Verified") {
                        data.verified = data.verified - 1
                      } else if (doc.status == "Rejected") {
                        data.rejected = data.rejected - 1
                      }
                      doc.status = status == "V" ? "Verified" : "Rejected";
                      doc.approved_by = loggedInUser;
                      doc.remark = remarks[selectedRecord.id];
                      if (doc.status == "Verified") {
                        data.verified = data.verified + 1
                      } else if (doc.status == "Rejected") {
                        data.rejected = data.rejected + 1
                      }
                    }
                  })
                }
              })
            }else{
              _.forEach(data.user_profile[type], function (document) {
                if (document.documents && document.documents.length > 0 && document.documents[0].id == selectedRecord.id) {
                  if (document.documents[0].status == "Pending Verification") {
                    data.pending = data.pending - 1
                  } else if (document.documents[0].status == "Verified") {
                    data.verified = data.verified - 1
                  } else if (document.documents[0].status == "Rejected") {
                    data.rejected = data.rejected - 1
                  }
                  document.documents[0].status = status == "V" ? "Verified" : "Rejected";
                  document.documents[0].approved_by = loggedInUser;
                  document.documents[0].remark = remarks[selectedRecord.id];
                  if (document.documents[0].status == "Verified") {
                    data.verified = data.verified + 1
                  } else if (document.documents[0].status == "Rejected") {
                    data.rejected = data.rejected + 1
                  }
                }
              })
            }
          }
        } else if (data.user_profile[type] && data.user_profile[type].documents && data.user_profile[type].documents.length > 0) {
          // (_.find(data.user_profile[type].documents, function(data){ return data.id == selectedRecord.id})).status = status == "V" ? "Verified" : "Rejected";
          _.forEach(data.user_profile[type].documents, function (document) {
            if (document.id == selectedRecord.id) {
              if (document.status == "Pending Verification") {
                data.pending = data.pending - 1
              } else if (document.status == "Verified") {
                data.verified = data.verified - 1
              } else if (document.status == "Rejected") {
                data.rejected = data.rejected - 1
              }
              document.status = status == "V" ? "Verified" : "Rejected";
              document.remark = remarks[selectedRecord.id];
              if (document.status == "Verified") {
                data.verified = data.verified + 1
              } else if (document.status == "Rejected") {
                data.rejected = data.rejected + 1
              }
            }
          })

        }
        newData.push(data)
      })
      // let doc = _.find(userDocs, function(data){ return data.id == selectedRecord.id})
      // let currentIndex = _.find(userDocs, function(data){ return data.id == selectedRecord.id})
      setUserData(newData)
      setUpdatedUserData(newData)
    })
      .catch((err) => {
        if ((type == 'experience' || type == 'educational_qualification' || type == 'training')) {
          alert('Please upload documents to continue.');
        }
        console.log(err);
      })
  }


  const expandRowRender = (i) => {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Code',
        dataIndex: 'user_code',
        key: 'user_code',
        sorter: true
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: true
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
        sorter: true
      },
      {
        title: 'Total Documents',
        dataIndex: 'total',
        key: 'total',
        sorter: true
      },
      {
        title: 'Verified',
        dataIndex: 'verified',
        key: 'verified',
        sorter: true
      },
      {
        title: 'Pending For Verification',
        dataIndex: 'pending',
        key: 'pending',
        sorter: true
      },
      {
        title: 'Rejected',
        dataIndex: 'rejected',
        key: 'rejected',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      }
    ];
    let data = [];
    if (i.type == 'Customer') {
      data = _.filter(updatedUserData, function (data) { return data.role == 'Customer' })
    } else {
      data = _.filter(updatedUserData, function (data) { return data.role == 'Provider' })
    }
    return <Table
      columns={columns}
      expandedRowRender={(i) => childRowRenderer(i)}
      expand
      dataSource={data}

    />
  };
  const childRowRenderer = (i) => {
    const columns = [
      {
        title: 'Verification Type',
        dataIndex: 'verificationType',
        key: 'verificationType',
      },
      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: (docName, record, index) => {
          const verificationType = record.verificationType == "Identity Verification" ? "identity_verification"
            : record.verificationType == "Residential Verification" ? "residential_address"
              : record.verificationType == "Bank Verification" ? "bank_detail"
                : record.verificationType == "Firm Verification" ? "firm_address"
                  : record.verificationType == "Educational Verification" ? "educational_qualification"
                    : record.verificationType == "Experience Verification" ? "experience"
                      : record.verificationType == "Primary Business" ? "primary_business"
                        : record.verificationType == "Vehicle Registration" ? "vehicle_registration"
                          : "training"

          return <div>

            {
              verificationType != "primary_business" &&
              <div>
                <Button
                  disabled={record.verificationData.status == "Verified" || (Array.isArray(record.verificationData) && record.verificationData.length == record.verificationData.filter(e => e.status && e.status == 'Verified').length && record.verificationData.length == record.verificationData.filter(e => e.documents.length && e.documents[0].status == 'Verified').length)}
                  type="primary" onClick={() => { approveReject(record, 'V', verificationType) }}>{record.verificationData.status == "Verified" || (isArray(record.verificationData) && record.verificationData.length == record.verificationData.filter(e => e.status && e.status == 'Verified').length && record.verificationData.length == record.verificationData.filter(e => e.documents.length && e.documents[0].status == 'Verified').length) ? 'Approved' : "Approve"}</Button>
                <Button
                  disabled={record.verificationData.status == "Rejected" || (Array.isArray(record.verificationData) && record.verificationData.length == record.verificationData.filter(e => e.status && e.status == 'Rejected').length && record.verificationData.length == record.verificationData.filter(e => e.documents.length && e.documents[0].status == 'Rejected').length)}
                  type="danger" onClick={() => { approveReject(record, 'R', verificationType) }}>{record.verificationData.status == "Rejected" || (isArray(record.verificationData) && record.verificationData.length == record.verificationData.filter(e => e.status && e.status == 'Rejected').length && record.verificationData.length == record.verificationData.filter(e => e.documents.length && e.documents[0].status == 'Rejected').length) ? 'Rejected' : "Reject"}</Button>
              </div>
            }
          </div>
        }

      },
    ];
    let data = []
    if (!(_.isEmpty(i.user_profile.identity_verification)))
      data.push({ verificationType: 'Identity Verification', verificationData: i.user_profile.identity_verification })
    if (!(_.isEmpty(i.user_profile.residential_address)))
      data.push({ verificationType: 'Residential Verification', verificationData: i.user_profile.residential_address })
    if (!(_.isEmpty(i.user_profile.bank_detail)))
      data.push({ verificationType: 'Bank Verification', verificationData: i.user_profile.bank_detail })
    if (!(_.isEmpty(i.user_profile.firm_address)))
      data.push({ verificationType: 'Firm Verification', verificationData: i.user_profile.firm_address })
    if (!(_.isEmpty(i.user_profile.educational_qualification)))
      data.push({ verificationType: 'Educational Verification', verificationData: i.user_profile.educational_qualification })
    if (!(_.isEmpty(i.user_profile.experience)))
      data.push({ verificationType: 'Experience Verification', verificationData: i.user_profile.experience })
    if (!(_.isEmpty(i.user_profile.training)))
      data.push({ verificationType: 'Training Verification', verificationData: i.user_profile.training })
    if (!(_.isEmpty(i.user_profile.primary_business)))
      data.push({ verificationType: 'Primary Business', verificationData: i.user_profile.primary_business })
    if (!(_.isEmpty(i.user_profile.vehicle_registration)))
      data.push({ verificationType: 'Vehicle Registration', verificationData: i.user_profile.vehicle_registration })
    return <Table columns={columns} expandedRowRender={(i) => childApprovalRowRenderer(i)} dataSource={data} pagination={false} />
  };

  const handleRemarkChange = (e, id) => {
    debugger
    const editRemarks = { ...remarks };
    editRemarks[id] = e.target.value;
    setRemarks(editRemarks);
  }

  const handleSumbitRemark = (selectedRecord, type) => {
    const data = {
      document_id: selectedRecord.id,
      remark: remarks[selectedRecord.id] || '',
      // approved_by: loggedInUser
    }
    dispatch(approveRejectUserDocument(data)).then((res) => {
      const newData = []
      _.forEach(updatedUserData, function (data) {
        if (type == 'experience' || type == 'educational_qualification' || type == 'training') {
          if (data.user_profile[type] && data.user_profile[type].length > 0) {
            _.forEach(data.user_profile[type], function (document) {
              if (document.documents && document.documents.length > 0 && document.documents[0].id == selectedRecord.id) {
                // if (document.documents[0].status == "Pending Verification") {
                //   data.pending = data.pending - 1
                // } else if (document.documents[0].status == "Verified") {
                //   data.verified = data.verified - 1
                // } else if (document.documents[0].status == "Rejected") {
                //   data.rejected = data.rejected - 1
                // }
                // document.documents[0].status = status == "V" ? "Verified" : "Rejected";
                document.documents[0].remark = remarks[selectedRecord.id];
                // if (document.documents[0].status == "Verified") {
                //   data.verified = data.verified + 1
                // } else if (document.documents[0].status == "Rejected") {
                //   data.rejected = data.rejected + 1
                // }
              }
            })
          }
        } else if (data.user_profile[type] && data.user_profile[type].documents && data.user_profile[type].documents.length > 0) {
          // (_.find(data.user_profile[type].documents, function(data){ return data.id == selectedRecord.id})).status = status == "V" ? "Verified" : "Rejected";
          _.forEach(data.user_profile[type].documents, function (document) {
            if (document.id == selectedRecord.id) {
              // if (document.status == "Pending Verification") {
              //   data.pending = data.pending - 1
              // } else if (document.status == "Verified") {
              //   data.verified = data.verified - 1
              // } else if (document.status == "Rejected") {
              //   data.rejected = data.rejected - 1
              // }
              // document.status = status == "V" ? "Verified" : "Rejected";
              document.documents[0].remark = remarks[selectedRecord.id];
              // if (document.status == "Verified") {
              //   data.verified = data.verified + 1
              // } else if (document.status == "Rejected") {
              //   data.rejected = data.rejected + 1
              // }
            }
          })

        }
        newData.push(data)
      })
      // let doc = _.find(userDocs, function(data){ return data.id == selectedRecord.id})
      // let currentIndex = _.find(userDocs, function(data){ return data.id == selectedRecord.id})
      setUserData(newData)
      setUpdatedUserData(newData)
    })
      .catch((err) => {
        console.log(err);
      })
  }

  const updatePrimaryBusiness = (currentSubCat, category, checked) => {
    let id = category.user_id;
    let existingSubCats = category.subcategory;
    let subcategories;
    if (checked) {
      subcategories = [...existingSubCats, { ...currentSubCat }]
    } else {
      subcategories = existingSubCats
      subcategories.splice(existingSubCats.findIndex(e => e.id == currentSubCat.id), 1)
    }
    var data = {
      user_id: id,
      category_id: category.category_id,
      subcategories
    }
    const token = (JSON.parse(localStorage.getItem('user'))).token;
    axios({
      url: `${apiEndPoint}/user/${id}/primarybusiness/${category.category_id}/`,
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      data: data
    }).then(() => {
      let newData = []
      updatedUserData.forEach(d => {
        if (d.id == id) {
          const businessIndex = d.user_profile.primary_business.findIndex(e => e.category.id == category.category_id)
          if (businessIndex != -1) {
            d.user_profile.primary_business[businessIndex].subcategories = subcategories

          }
        }
        newData.push(d)
      })
      setUserData(newData)
    })

  }

  const subcategoryRowRenderer = (i) => {
    const columns = [
      {
        title: 'Subcategory Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Select Subcategory',
        dataIndex: 'id',
        key: 'id',
        render: (catName, record, index) => (
          <div>
            <input style={{ height: '20px', width: '20px' }} type="checkbox" id="myCheckbox" name="myCheckbox" checked={record.isChecked} onChange={(e) => updatePrimaryBusiness(record, i, e.target.checked)} />
          </div>
        ),
      },
    ];
    let data = [];

    let subcategories = (allCategories.find(e => e.name == i.catName)).subcategory
    subcategories.forEach(s => {
      const existingSubCat = i.subcategory.find(sub => sub.id == s.id);
      if (existingSubCat) {
        s.isChecked = true
      } else {
        s.isChecked = false
      }
      data.push(s)
    })

    return <Table
      columns={columns}
      dataSource={subcategories}
      pagination={false} />
  }

  const childApprovalRowRenderer = (i) => {
    let columns = [];

    if (i.verificationType == 'Residential Verification') {
      columns = [
        {
          title: 'Address Line 1',
          dataIndex: 'address_line1',
          key: 'address_line1',
        },
        {
          title: 'Address Line 2',
          dataIndex: 'address_line2',
          key: 'address_line2',
        },
        {
          title: 'City',
          dataIndex: 'city',
          key: 'city',
        },
        {
          title: 'Country',
          dataIndex: 'country',
          key: 'country',
        },
        {
          title: 'State',
          dataIndex: 'state',
          key: 'state',
        },
        {
          title: 'Zip',
          dataIndex: 'zip',
          key: 'zip',
        },
        {
          title: 'Latitude',
          dataIndex: 'lat',
          key: 'lat',
        },
        {
          title: 'Longitude',
          dataIndex: 'lon',
          key: 'lon',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'residential_address')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Bank Verification') {
      columns = [
        {
          title: 'Account Holder Name',
          dataIndex: 'account_holder_name',
          key: 'account_holder_name',
        },
        {
          title: 'Account No',
          dataIndex: 'account_no',
          key: 'account_no',
        },
        {
          title: 'Account Type',
          dataIndex: 'account_type',
          key: 'account_type',
        },
        {
          title: 'IFSC Code',
          dataIndex: 'bank_ifsc',
          key: 'bank_ifsc',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'bank_detail') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'bank_detail') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'residential_address')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Firm Verification') {
      columns = [
        {
          title: 'Firm Name',
          dataIndex: 'firm_name',
          key: 'firm_name',
        },
        {
          title: 'GST No',
          dataIndex: 'gst',
          key: 'gst',
        },
        {
          title: 'PAN',
          dataIndex: 'pan',
          key: 'pan',
        },
        {
          title: 'Entity Reg No',
          dataIndex: 'entity_reg_no',
          key: 'entity_reg_no',
        },
        {
          title: 'Address Line 1',
          dataIndex: 'address_line1',
          key: 'address_line1',
        },
        {
          title: 'Address Line 2',
          dataIndex: 'address_line2',
          key: 'address_line2',
        },
        {
          title: 'City',
          dataIndex: 'city',
          key: 'city',
        },
        {
          title: 'Country',
          dataIndex: 'country',
          key: 'country',
        },
        {
          title: 'State',
          dataIndex: 'state',
          key: 'state',
        },
        {
          title: 'Zip',
          dataIndex: 'zip',
          key: 'zip',
        },
        {
          title: 'Latitude',
          dataIndex: 'lat',
          key: 'lat',
        },
        {
          title: 'Longitude',
          dataIndex: 'lon',
          key: 'lon',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'firm_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'firm_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'firm_address')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Identity Verification') {
      columns = [
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'identity_verification') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'identity_verification') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'identity_verification')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Educational Verification') {
      columns = [
        {
          title: 'Qualification',
          dataIndex: 'qualification',
          key: 'qualification',
        },
        {
          title: 'Degree',
          dataIndex: 'degree_name',
          key: 'degree_name',
        },
        {
          title: 'Specilization',
          dataIndex: 'subject_of_specialization',
          key: 'subject_of_specialization',
        },
        {
          title: 'Institution Name',
          dataIndex: 'institute_name',
          key: 'institute_name',
        },
        {
          title: 'Board',
          dataIndex: 'board',
          key: 'board',
        },
        {
          title: 'Grade',
          dataIndex: 'grade',
          key: 'grade',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'educational_qualification') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'educational_qualification') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'educational_qualification')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Experience Verification') {
      columns = [
        {
          title: 'Organization Name',
          dataIndex: 'organization_name',
          key: 'organization_name',
        },
        {
          title: 'Organization Address',
          dataIndex: 'organization_address',
          key: 'organization_address',
        },
        {
          title: 'Relieving Date',
          dataIndex: 'relieving_date',
          key: 'relieving_date',
        },
        {
          title: 'Designation',
          dataIndex: 'designation',
          key: 'designation',
        },
        {
          title: 'Job Type',
          dataIndex: 'job_type',
          key: 'job_type',
        },
        {
          title: 'Reason For Leaving',
          dataIndex: 'reason_for_leaving',
          key: 'reason_for_leaving',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'experience') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'experience') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'experience')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Training Verification') {
      columns = [
        {
          title: 'Certification Name',
          dataIndex: 'certificate_name',
          key: 'certificate_name',
        },
        {
          title: 'Certification Type',
          dataIndex: 'certificate_type',
          key: 'certificate_type',
        },
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
        },
        {
          title: 'Validity',
          dataIndex: 'validity',
          key: 'validity',
        },
        {
          title: 'Grade',
          dataIndex: 'grade',
          key: 'grade',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'training') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'training') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              {/* <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'residential_address') }}>{record.status == "Verified" ? 'Approved' : "Approve"}</Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'residential_address') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"}</Button>
              </div> */}
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
              {/* <Button className='submit-button' type="primary" onClick={() => handleSumbitRemark(record, 'training')}>Sumbit</Button> */}
            </div>
          ),
        },
      ];
    } else if (i.verificationType == 'Primary Business') {
      columns = [
        {
          title: 'Category Name',
          dataIndex: 'catName',
          key: 'catName',
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (catName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectPrimaryBusiness(record, 'V') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectPrimaryBusiness(record, 'R') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
      ];
    } else if(i.verificationType == 'Vehicle Registration'){
      columns = [
        {
          title: 'Vehicle Type',
          dataIndex: 'vechicle_type_detail',
          key: 'vechicle_type_detail',
        },
        {
          title: 'RC No',
          dataIndex: 'rc_no',
          key: 'rc_no',
        },
        {
          title: 'RC Valid From',
          dataIndex: 'rc_valid_from',
          key: 'rc_valid_from',
        },
        {
          title: 'RC Valid To',
          dataIndex: 'rc_valid_to',
          key: 'rc_valid_to',
        },
        {
          title: 'DL No',
          dataIndex: 'dl_no',
          key: 'dl_no',
        },
        {
          title: 'DL Valid From',
          dataIndex: 'dl_valid_from',
          key: 'dl_valid_from',
        },
        {
          title: 'DL Valid To',
          dataIndex: 'dl_valid_to',
          key: 'dl_valid_to',
        },
        {
          title: 'Insurance No',
          dataIndex: 'insurance_no',
          key: 'insurance_no',
        },
        {
          title: 'Insurance Valid From',
          dataIndex: 'insurance_valid_from',
          key: 'insurance_valid_from',
        },
        {
          title: 'Insurance Valid To',
          dataIndex: 'insurance_valid_to',
          key: 'insurance_valid_to',
        },
        {
          title: 'Tax No',
          dataIndex: 'tax_no',
          key: 'tax_no',
        },
        {
          title: 'Tax Valid From',
          dataIndex: 'tax_valid_from',
          key: 'tax_valid_from',
        },
        {
          title: 'Tax Valid To',
          dataIndex: 'tax_valid_to',
          key: 'tax_valid_to',
        },
        {
          title: 'PUC No',
          dataIndex: 'puc_no',
          key: 'puc_no',
        },
        {
          title: 'PUC Valid From',
          dataIndex: 'puc_valid_from',
          key: 'puc_valid_from',
        },
        {
          title: 'PUC Valid To',
          dataIndex: 'puc_valid_to',
          key: 'puc_valid_to',
        },
        {
          title: 'Document Name',
          dataIndex: 'docName',
          key: 'docName',
        },
        {
          title: 'Document No',
          dataIndex: 'docNo',
          key: 'docNo',
        },
        {
          title: 'Approved By',
          dataIndex: 'approvedBy',
          key: 'approvedBy',
        },
        {
          title: 'Uploaded Document',
          dataIndex: 'uploadedDoc',
          key: 'uploadedDoc',
          render: (docName, record, index) => (
            <div onClick={() => openImageModal(record)} style={{ color: 'blue', cursor: 'pointer' }}>
              Open Document
            </div>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (docName, record, index) => (
            <div>
              <div>
                <Button disabled={record.status == "Verified"} type="primary" onClick={() => { approveRejectDocuments(record, 'V', 'vehicle_registration') }}>{record.status == "Verified" ? 'Approved' : "Approve"} </Button>
                <Button disabled={record.status == "Rejected"} type="danger" onClick={() => { approveRejectDocuments(record, 'R', 'vehicle_registration') }}>{record.status == "Rejected" ? 'Rejected' : "Reject"} </Button>
              </div>
            </div>
          ),
        },
        {
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          render: (docName, record, index) => (
            <div>
              <input className="remark-input" value={remarks[record.id]} onChange={(e) => handleRemarkChange(e, record.id)} />
            </div>
          ),
        },
      ];
    }

    let data = [];
    if (i.verificationType == 'Identity Verification') {
      _.forEach(i.verificationData.documents, function (document) {
        data.push({ user_id: i.verificationData.user_id, docName: document.document_name, docNo: document.document_no, approvedBy: document.approved_by, id: document.id, docType: document.document_type, status: document.status, url: document.document_url })
      })
    } else if (i.verificationType == 'Residential Verification') {
      _.forEach(i.verificationData.documents, function (document) {
        data.push({ user_id: i.verificationData.user_id, address_line1: i.verificationData.address_line1, lat: i.verificationData.location_latitude, lon: i.verificationData.location_longitude, address_line2: i.verificationData.address_line2, city: i.verificationData.city, country: i.verificationData.country, state: i.verificationData.state, zip: i.verificationData.zip, docName: document.document_name, docNo: document.document_no, approvedBy: document.approved_by, id: document.id, docType: document.document_type, status: document.status, url: document.document_url })
      })
    } else if (i.verificationType == 'Bank Verification') {
      _.forEach(i.verificationData.documents, function (document) {
        data.push({ user_id: i.verificationData.user_id, account_holder_name: i.verificationData.account_holder_name, account_no: i.verificationData.account_no, account_type: i.verificationData.account_type, bank_ifsc: i.verificationData.bank_ifsc, bankStatus: i.verificationData.status, docName: document.document_name, docNo: document.document_no, approvedBy: document.approved_by, id: document.id, docType: document.document_type, status: document.status, url: document.document_url })
      })
    } else if (i.verificationType == 'Firm Verification') {
      _.forEach(i.verificationData.documents, function (document) {
        data.push({ user_id: i.verificationData.user_id, firm_name: i.verificationData.firm_name, lat: i.verificationData.location_latitude, lon: i.verificationData.location_longitude, gst: i.verificationData.gst_no, pan: i.verificationData.pan, entity_reg_no: i.verificationData.entity_reg_no, address_line1: i.verificationData.address_line1, address_line2: i.verificationData.address_line2, city: i.verificationData.city, country: i.verificationData.country, state: i.verificationData.state, zip: i.verificationData.zip, bankStatus: i.verificationData.status, docName: document.document_name, docNo: document.document_no, approvedBy: document.approved_by, id: document.id, docType: document.document_type, status: document.status, url: document.document_url })
      })
    } else if (i.verificationType == 'Primary Business') {
      _.forEach(i.verificationData, function (business) {
        data.push({ catName: business.category.name, id: business.id, category_id: business.category.id, user_id: business.user_id, status: business.status, subcategory: business.subcategories })
      })
      return <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        expandedRowRender={(i) => subcategoryRowRenderer(i)}
      />
    } else if (i.verificationType == 'Experience Verification') {
      _.forEach(i.verificationData, function (education) {
        data.push({ user_id: education.user_id, data_id: education.id, organization_name: education.organization_name, organization_address: education.organization_address, relieving_date: education.relieving_date, designation: education.designation, job_type: education.job_type, reason_for_leaving: education.grade, docName: education.documents && education.documents.length > 0 && education.documents[0].document_name, docNo: education.documents && education.documents.length > 0 && education.documents[0].document_no, approvedBy: education.documents && education.documents.length > 0 && education.documents[0].approved_by, id: education.documents && education.documents.length > 0 && education.documents[0].id, docType: education.documents && education.documents.length > 0 && education.documents[0].document_type, status: education.documents && education.documents.length > 0 && education.documents[0].status, url: education.documents && education.documents.length > 0 && education.documents[0].document_url })
      })
    } else if (i.verificationType == 'Educational Verification') {
      _.forEach(i.verificationData, function (education) {
        data.push({ user_id: education.user_id, data_id: education.id, qualification: education.qualification, degree_name: education.degree_name, subject_of_specialization: education.subject_of_specialization, institute_name: education.institute_name, board: education.board, grade: education.grade, docName: education.documents && education.documents.length > 0 && education.documents[0].document_name, docNo: education.documents && education.documents.length > 0 && education.documents[0].document_no, approvedBy: education.documents && education.documents.length > 0 && education.documents[0].approved_by, id: education.documents && education.documents.length > 0 && education.documents[0].id, docType: education.documents && education.documents.length > 0 && education.documents[0].document_type, status: education.documents && education.documents.length > 0 && education.documents[0].status, url: education.documents && education.documents.length > 0 && education.documents[0].document_url })
      })
    } else if (i.verificationType == 'Training Verification') {
      _.forEach(i.verificationData, function (education) {
        data.push({ user_id: education.user_id, data_id: education.id, certificate_name: education.certificate_name, certificate_type: education.certificate_type, date: education.date, validity: education.validity, grade: education.grade, docName: education.documents && education.documents.length > 0 && education.documents[0].document_name, docNo: education.documents && education.documents.length > 0 && education.documents[0].document_no, approvedBy: education.documents && education.documents.length > 0 && education.documents[0].approved_by, id: education.documents && education.documents.length > 0 && education.documents[0].id, docType: education.documents && education.documents.length > 0 && education.documents[0].document_type, status: education.documents && education.documents.length > 0 && education.documents[0].status, url: education.documents && education.documents.length > 0 && education.documents[0].document_url })
      })
    }else if (i.verificationType == 'Vehicle Registration') {
      _.forEach(i.verificationData, function (education) {
        _.forEach(education.documents, function(vehDocs){
          data.push({ user_id: education.user_id, vechicle_type_detail: education.vechicle_type_detail, data_id: education.id, rc_no: education.rc_no, rc_valid_from: education.rc_valid_from, rc_valid_to: education.rc_valid_to, dl_no: education.dl_no, dl_valid_from: education.dl_valid_from, dl_valid_to: education.dl_valid_to,insurance_no: education.insurance_no, insurance_valid_from: education.insurance_valid_from, insurance_valid_to: education.insurance_valid_to, tax_no: education.tax_no, tax_valid_from: education.tax_valid_from, tax_valid_to: education.tax_valid_to, puc_no: education.puc_no, puc_valid_from: education.puc_valid_from, puc_valid_to: education.puc_valid_to,  docName: vehDocs.document_name, docNo: vehDocs.document_no, approvedBy: vehDocs.approved_by, id: vehDocs.id, docType: vehDocs.document_type, status: vehDocs.status, url: vehDocs.document_url })
        })
      })
    }
    return <Table
      columns={columns}
      dataSource={data}
      pagination={false}
    />
  };

  // const columns = [
  //   {
  //     title: 'Type',
  //     dataIndex: 'type',
  //     key: 'type',
  //   },
  // ];
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true
    },
    {
      title: 'Code',
      dataIndex: 'user_code',
      key: 'user_code',
      sorter: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: true
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      sorter: true
    },
    {
      title: 'Total Documents',
      dataIndex: 'total',
      key: 'total',
      sorter: true
    },
    {
      title: 'Verified',
      dataIndex: 'verified',
      key: 'verified',
      sorter: true
    },
    {
      title: 'Pending For Verification',
      dataIndex: 'pending',
      key: 'pending',
      sorter: true
    },
    {
      title: 'Rejected',
      dataIndex: 'rejected',
      key: 'rejected',
      sorter: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true
    }
  ];
  const data = [{ key: "1", type: 'Customer' }, { key: "2", type: 'Provider' }];

  const openImageModal = (record) => {
    setCurrentSelectedDoc(`${imageEndpoint}${record.url}`)
    showModal();
  }

  const handleSearch = (value) => {
    let updatedUserData = [...userData];
    if (value !== "") {
      updatedUserData = updatedUserData.filter((item) =>
        Object.values(item).some((val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
        )
      )
    }
    setUpdatedUserData(updatedUserData)
  }

  return (
    <>
      <Input placeholder="Search User" style={{ width: '300px', marginBottom: '20px' }} onChange={(e) => handleSearch(e.target.value)} />
      <Table
        columns={columns}
        expandedRowRender={(i) => childRowRenderer(i)}
        onChange={(pagination, filters, sorter) => {
          handleSort(sorter.field);
        }}
        sortDirections={['ascend', 'descend']}
        sortOrder={sortOrder}
        expand
        dataSource={updatedUserData}
        pagination={false}
      />
      <Modal title="Basic Modal" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <img
          alt="doc"
          src={currentSelectedDoc}
          width="500"
        />
      </Modal>
    </>
  );
};
export default TableComponent;
